export {default} from './EventListener';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/EventListener/index.ts